import './Loader.scss'

function Loader() {
    return(
        <svg
            width="100px"  height="100px" viewBox="0 0 64.000000 64.000000">

            <g className="wine" transform="translate(0.000000,64.000000) scale(0.100000,-0.100000)">
            <path d="M281 616 c-7 -8 -9 -35 -5 -72 5 -55 3 -62 -31 -114 -27 -42 -35 -64
            -33 -90 l3 -35 68 -3 67 -3 0 -59 0 -60 -70 0 -70 0 0 -53 c0 -69 20 -89 93
            -95 87 -7 154 33 113 67 -22 18 -151 10 -151 -9 0 -11 12 -15 43 -16 l42 -1
            -40 4 c-61 6 -47 23 19 23 96 0 119 -19 56 -46 -59 -24 -134 -15 -157 20 -4 6
            -8 30 -8 54 l0 42 70 0 70 0 0 70 0 69 -67 3 c-67 3 -68 3 -71 33 -2 21 8 47
            33 85 33 50 36 61 33 114 -2 47 0 61 15 70 12 8 22 8 35 0 14 -9 16 -22 14
            -68 -4 -50 0 -62 30 -108 32 -51 33 -56 39 -183 l5 -130 2 123 c2 129 -3 149
            -51 214 -17 23 -19 36 -13 84 4 37 3 61 -5 70 -15 18 -63 18 -78 0z"/>
            </g>
        </svg>

    )
}

export default Loader